import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './App';
import ScrollToHash from "./components/ScrollToHash"; //for hash links mannualy
// import ContactUs from './pages/ContactUs';

import Portofoliopage from './pages/PortfolioPage';

//auth
import PageNotFound from "./pages/PageNotFound";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <React.StrictMode>
      <BrowserRouter>
   <ScrollToHash />
      <Routes> 
        {/* public pages */}
        <Route path="/" element={<Home/>} />
        {/* <Route path="/contact" element={<ContactUs/>} />         */}

        
          <Route path="/" element={<Home/>} />
            <Route path="/portfolio" element={<Portofoliopage />} />
     
      
      <Route path="*" element={<PageNotFound />} />
      </Routes>

    </BrowserRouter>
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
